module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img25.7766cf86.jpg";